export default {
    name: 'TimelineEntryItem',
    emits: [
        'mouseenter',
        'mouseleave'
    ]
};
